import { FC, useCallback } from 'react';
import { useForm, useField } from 'react-final-form';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { readCarInfo } from 'src/api/plan';
import { FormPersonAutocomplete } from 'src/components/FormPersonAutocomplete/FormPersonAutocomplete';
import { FormSwitch } from 'src/components/FormSwitch/FormSwitch';
import { FormTextField } from 'src/components/FormTextField/FormTextField';
import { messagesActions } from 'src/store/messages/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { defaultServerError } from 'src/utils/consts';

import classes from './BookedForField.module.scss';

export const BookedForField: FC = () => {
  const dispatch = useAppDispatch();
  const { change } = useForm();
  const guest = useField<boolean>('guest').input.value;

  const handleChangeResponsible = useCallback(
    async (option: Option<string> | null) => {
      let model = '';
      let number = '';

      if (option) {
        try {
          const carInfo = await readCarInfo(option.id as string);
          model = carInfo.model ?? '';
          number = carInfo.number ?? '';
        } catch (e) {
          dispatch(messagesActions.show({ message: defaultServerError }));
        }
      }

      change('model', model);
      change('number', number);
    },
    [change, dispatch],
  );

  const handleIsGuestChange = useCallback(() => {
    change('guestName', '');
    change('responsible', null);
    change('model', '');
    change('number', '');
  }, [change]);

  return (
    <div className={classes.bookedFor}>
      <div className={classes.bookedForSwitch}>
        <FormSwitch
          name='guest'
          label='На гостя'
          onChange={handleIsGuestChange}
        />
      </div>

      {guest ? (
        <FormTextField
          name='guestName'
          size='medium'
          label='ФИО гостя'
          required
          fullWidth
        />
      ) : (
        <FormPersonAutocomplete
          name='responsible'
          type='select'
          label='ФИО сотрудника'
          required
          onChange={handleChangeResponsible}
        />
      )}
    </div>
  );
};
